import WarningAlertComponent from '../WarningAlert.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChildAlertProps } from '../BaseAlert.component';

const CandidateRemoveAlertComponent = ({ handleConfirm }: ChildAlertProps) => {
  const { t } = useTranslation();

  return (
    <WarningAlertComponent onClose={handleConfirm}>
      {t('Candidate will be removed')}.
      <br />
      {t('Continue')}?
    </WarningAlertComponent>
  );
};

export default CandidateRemoveAlertComponent;
